import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private http: HttpService) { }

  getCompanies(params: any): Observable<any> {
    return this.http.get('Company', params);
  }

  getCompany(id: string): Observable<any> {
    return this.http.get(`Company/${id}`);
  }

  addOrUpdateCompany(companyData: any): Observable<any> {
    return this.http.post('Company', companyData);
  }

  deleteCompany(id: string): Observable<any> {
    return this.http.delete(`Company/${id}`);
  }

  addUserCompany(userData: any): Observable<any> {
    return this.http.post('Company/User', userData);
  }

  updateUserCompany(userData: any): Observable<any> {
    return this.http.put('Company/User', userData);
  }

  addContactCompany(companyData: any): Observable<any> {
    return this.http.post('Company/Contact', companyData);
  }

  getContact(params: any): Observable<any> {
    return this.http.get('Company/Contact', params);
  }

  transferContactToCompany(id: any): Observable<any> {
    return this.http.post(`Company/Contact/${id}`);
  }

  updateContact(data: any): Observable<any> {
    return this.http.put('Company/Contact', data);
  }

  deleteContact(id: any) {
    return this.http.delete(`Company/Contact/${id}`);
  }

  getCompanySubscriptions(companyId: string) {
    return this.http.get(`Company/CompanySubscription/${companyId}`);
  }

  addOrUpdateCompanySubscription(payload: any) {
    return this.http.post("Company/CompanySubscription", payload);
  }

  getCompanySubscriptionHistory(params: any, companyId: string) {
    return this.http.get(`Company/CompanySubscription/history/${companyId}`, params)
  }

  getFeatures() {
    return this.http.get('Admin/Features');
  }
  
  getCompanyActivities(companyId: string) {
    return this.http.get(`Company/CompanyActivities/${companyId}`);
  }

  getDeedReport(companyId: string, params: any) {
    return this.http.get(`Company/Deed/${companyId}`, { params });
  }
}
